// Bernie
import { AnalyticsStore, codeSplit, Controller, FetchOptions, Result } from 'bernie-core';
import { PageData } from 'bernie-http';

// Client
import 'client/temp-common-imports';

// Stores
import { QuicklinkStore, UiStore } from 'stores';

// Utils
import analyticsUtil from '../util/AnalyticsUtil';
import { pageNames } from '../data/page-names';

class QuicklinksController implements Controller {
  public bundles = [];

  public component = codeSplit(() => import(/* webpackChunkName: "quicklinks-page" */ '../views/quicklinks-page'));

  public pageId = pageNames.quicklinks;

  public path = '/:localeName/quicklinks';
  public exact = true;

  public routeName = 'quicklinks';

  public fetch(options: FetchOptions) {
    const { query, request, stores } = options;

    const pageName = 'page.Marketing.Affiliate.Hub.Products.Quicklinks';

    const analyticsStore = stores?.get<AnalyticsStore>('analytics');
    const quicklinkStore = stores?.get<QuicklinkStore>('quicklinks');

    const uiStore = stores?.get<UiStore>('uiStore');
    uiStore?.setPageName(this.pageId);

    analyticsUtil.runAnalytics(pageName, analyticsStore, request.context);

    quicklinkStore?.fetch(query.programName);

    return Promise.resolve(Result.ok());
  }

  public fetchPageData() {
    const pageData: PageData = {
      title: 'Affiliate Hub Quicklinks',
    };

    return Promise.resolve(pageData);
  }
}

export { QuicklinksController };
